import React from "react";
import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Container, Typography, Box } from "@mui/material"
import BgContainer2 from "./CommonC/BgContainer2";
import SelexSolNavbar from "./CommonC/SelexSolNavbar";
import { Paper } from "@mui/material";
import { baseURL } from "../Config/config";
import GlobalLoader from "./CommonC/GlobalLoader";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import { IconButton } from "@mui/material";
import { TextField, Button } from "@mui/material"

import Projectcolors from "../Utils/Colors";



const stylec = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  height: 480,
  bgcolor: "white",
  border: "0px solid #000",
  p: 4,
  display: "block",
};


function BlogPreview(){
    const navigate = useNavigate()
    
    const handleOpenc = () => setOpenc(true);
    const handleOpen = () => setOpen(true);
    const [openc, setOpenc] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [blog, setBlog] = React.useState({});
      const handleClosec = () => setOpenc(false);
      const [loader, setLoader] = React.useState(false);
      const [comments,setComments] = useState([])
const [name,setName] = useState("")
const [email,setEmail] = useState("")
const [comment,setComment] = useState("")
const [replyText, setReplyText] = useState("")
const [replyName, setReplyName] = useState("")

const [activeReply, setActiveReply] = useState(null)



      

const {slug} = useParams()
const shareUrl = `https://selexsuite.com/blog/${slug}?v=${Date.now()}`;
useEffect(async () => {
    await displayBlog();
    //await getComments();
  }, []);
  const getComments = async ()=>{

let res = await fetch(`${baseURL}/getcomments/${slug}`)
res = await res.json()

setComments(res.comments)

}
const submitReply = async (commentId) => {

  if(!replyText){
    alert("Reply cannot be empty")
    return
  }

  try{
    const today = new Date().toISOString().split("T")[0];

    const requestOptions = {
      method:"POST",
      headers:{
        "Content-Type":"application/json"
      },
      body: JSON.stringify({
        comment_id: commentId,
        name: replyName,
        comment: replyText,
        date:today
      })
    }

    let res = await fetch(`${baseURL}/replycomment`,requestOptions)
    res = await res.json()

    if(res.status === "success"){
      setReplyText("")
      setActiveReply(null)
      getComments()
    }

  }catch(error){
    console.log(error)
  }

}


const displayBlog = async ()=>{
    setLoader(true)

  const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(slug),
      };
      try {
        let res = await fetch(`${baseURL}/displayblog`, requestOptions);
        res = await res.json();
        console.log(res)
        setBlog(res['blog'] || {})
        setLoader(false)
       
      } catch (error) {
        setLoader(false)

        alert("Some Error", error);
        console.log("err", error);
      }

}

const addComment = async () => {

  if (!name || !email || !comment) {
    alert("Please fill all fields")
    return
  }

  try {
    const today = new Date().toISOString().split("T")[0];
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        slug: slug,
        name: name,
        email: email,
        comment: comment,
        date:today
      })
    }

    let res = await fetch(`${baseURL}/addcomment`, requestOptions)
    res = await res.json()

    if (res.status === "success") {

      // reload comments from DB
      getComments()

      // clear form
      setName("")
      setEmail("")
      setComment("")
    }

  } catch (error) {
    console.log("Comment error", error)
    alert("Error adding comment")
  }

}

const likeComment = async (commentId) => {

  try {

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        comment_id: commentId
      }),
    };

    let res = await fetch(`${baseURL}/likecomment`, requestOptions);
    res = await res.json();

    if(res.status === "liked"){
      getComments(); // reload comments to update like count
    }

  } catch (error) {
    console.log("Like error", error);
  }

};


return (


  <Box
    sx={{
      minHeight: "100vh",
      background:"#fff",
      overflowX: "hidden",
    }}
  >
    <SelexSolNavbar isLoggedIn={!!sessionStorage.getItem("usertoken")}/>

    <Container maxWidth="lg" sx={{ pt: { xs: 2, md: 4 }, pb: 7 }}>
      {/* ARTICLE HEADER */}
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Typography
          sx={{
            color: "#9e0b22",
            fontSize: 12,
            fontWeight: 950,
            letterSpacing: 1.4,
            textTransform: "uppercase",
            mb: 1,
          }}
        >
          Blog Article
        </Typography>

        <Typography
          sx={{
            fontSize: { xs: 22, md: 44 },
            fontWeight: 700,
            color: "#082f56",
            letterSpacing: "-1.8px",
            lineHeight: 1.12,
            mb: 2,
          }}
        >
          {blog.title}
        </Typography>

        <Typography
          sx={{
            color: "#000",
            fontSize: 16,
            fontWeight: 700,
          }}
        >
          By {blog.author}
        </Typography>
      </Box>

      {/* FEATURE IMAGE */}
      <Box
        sx={{
          position: "relative",
          borderRadius: "34px",
          overflow: "hidden",
          boxShadow: "0 24px 70px rgba(6,29,52,0.16)",
          mb: 4,
        }}
      >
        <Box
          component="img"
          src={blog.image}
          alt={blog.title}
          sx={{
            width: "100%",
            height: { xs: 260, md: 460 },
            objectFit: "cover",
            display: "block",
          }}
        />

        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(to top, rgba(6,29,52,0.72), transparent 60%)",
          }}
        />

      </Box>

      {/* ARTICLE CONTENT CARD */}
      <Box
        sx={{
          background: "rgba(255,255,255,0.94)",
          border: "1px solid rgba(0,120,201,0.13)",
          borderRadius: "32px",
          boxShadow: "0 18px 50px rgba(6,29,52,0.08)",
          p: { xs: 3, md: 5 },
          mb: 4,
        }}
      >
       <Box
  className="blog-content"
  sx={{
    fontFamily: "Arial, Helvetica, sans-serif",

    fontSize: {
      xs: "16px",
      md: "17px",
    },

    lineHeight: 1.65,

    color: "#334155",

    "& p": {
      marginTop: 0,
      marginBottom: "12px",
    },

    "& h1": {
      fontSize: {
        xs: "30px",
        md: "36px",
      },
      lineHeight: 1.2,
      fontWeight: 800,
      color: "#061d34",
      marginTop: "30px",
      marginBottom: "16px",
    },

    "& h2": {
      fontSize: {
        xs: "26px",
        md: "30px",
      },
      lineHeight: 1.25,
      fontWeight: 800,
      color: "#061d34",
      marginTop: "26px",
      marginBottom: "14px",
    },

    "& h3": {
      fontSize: {
        xs: "21px",
        md: "24px",
      },
      lineHeight: 1.3,
      fontWeight: 700,
      color: "#061d34",
      marginTop: "22px",
      marginBottom: "12px",
    },

    "& ul, & ol": {
      marginTop: "12px",
      marginBottom: "12px",
      paddingLeft: "28px",
    },

    "& li": {
      marginBottom: "6px",
    },

    "& blockquote": {
      borderLeft: "4px solid #0078c9",
      margin: "20px 0",
      padding: "12px 20px",
      background: "#f8fbff",
      color: "#475569",
    },

    "& img": {
      maxWidth: "100%",
      height: "auto",
      display: "block",
      margin: "22px auto",
      borderRadius: "18px",
      boxShadow: "0 14px 34px rgba(6,29,52,0.10)",
    },

    "& a": {
      color: "#0078c9",
      fontWeight: 600,
      textDecoration: "underline",
    },

    "& iframe": {
      maxWidth: "100%",
      width: "100%",
      minHeight: "420px",
      border: 0,
      borderRadius: "16px",
      margin: "22px 0",
    },
  }}
  dangerouslySetInnerHTML={{ __html: blog.content }}
/>
      </Box>

      {/* SHARE BOX */}
      <Box
        sx={{
          p: { xs: 2.5, md: 3 },
          borderRadius: "28px",
          background: "#061d34",
          color: "#fff",
          boxShadow: "0 20px 55px rgba(6,29,52,0.16)",
          mb: 4,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <Box>
          <Typography sx={{ fontSize: 20, fontWeight: 950 }}>
            Share this article
          </Typography>
          <Typography sx={{ color: "rgba(255,255,255,0.62)", fontSize: 16 }}>
            Send this insight to your network
          </Typography>
        </Box>

        <Box sx={{ display: "flex", gap: 1 }}>
          {[
            {
  icon: <FacebookIcon />,
  url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
},
{
  icon: <TwitterIcon />,
  url: `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}`,
},
{
  icon: <LinkedInIcon />,
  url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,
},
          ].map((item, index) => (
            <IconButton
              key={index}
              onClick={() =>   item.url}
              sx={{
                width: 44,
                height: 44,
                color: "#fff",
                background:
                  index % 2 === 0
                    ? "rgba(0,120,201,0.22)"
                    : "rgba(158,11,34,0.22)",
                border: "1px solid rgba(255,255,255,0.12)",
                "&:hover": {
                  background:
                    index % 2 === 0
                      ? "#0078c9"
                      : "#9e0b22",
                  transform: "translateY(-2px)",
                },
              }}
            >
              {item.icon}
            </IconButton>
          ))}
        </Box>
      </Box>

      {/* COMMENTS */}
      <Box
        sx={{
          p: { xs: 3, md: 4 },
          borderRadius: "32px",
          background: "#fff",
          border: "1px solid rgba(0,120,201,0.14)",
          boxShadow: "0 18px 50px rgba(6,29,52,0.08)",
          mb: 4,
        }}
      >
        <Typography
          sx={{
            color: "#061d34",
            fontSize: 26,
            fontWeight: 700,
            mb: 3,
          }}
        >
          Comments
        </Typography>

        {comments.length === 0 && (
          <Typography sx={{ color: "#000", fontSize: 16 }}>
            No comments yet. Be the first to share your thoughts.
          </Typography>
        )}

        <Box display="flex" flexDirection="column" gap={2}>
          {comments.map((c) => (
            <Box
              key={c._id}
              sx={{
                p: 2.5,
                borderRadius: "22px",
                background: "rgba(0,120,201,0.04)",
                border: "1px solid rgba(0,120,201,0.12)",
              }}
            >
              <Typography sx={{ fontWeight: 700, color: "#061d34", fontSize: 16 }}>
                {c.name}
              </Typography>

              <Typography sx={{ color: "#000", fontSize: 12 }}>
                {c.date}
              </Typography>

              <Typography sx={{ mt: 1.5, color: "#000", fontSize: 16, lineHeight: 1.7 }}>
                {c.comment}
              </Typography>

              <Box sx={{ display: "flex", gap: 1, mt: 1.5 }}>
                <Button
  size="small"
  onClick={() => likeComment(c._id)}
  sx={{
    color: "#0078c9",
    fontWeight: 800,
    textTransform: "none",
    fontSize: "12px",
  }}
>
  <span
    style={{
      fontSize: "12px",
      marginRight: "5px",
      lineHeight: 1,
    }}
  >
    👍
  </span>

  {c.likes}
</Button>
                <Button
                  size="small"
                  onClick={() => setActiveReply(c._id)}
                  sx={{
                    color: "#9e0b22",
                    fontWeight: 700,
                    fontSize:12,
                    textTransform: "none",
                  }}
                >
                  Reply
                </Button>
              </Box>

              {activeReply === c._id && (
                <Box mt={2}>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Name"
                    value={replyName}
                    onChange={(e) => setReplyName(e.target.value)}
                    sx={{
    ...fieldStyle,
    "& .MuiInputBase-input::placeholder": {
      fontSize: "16px", // change as needed
      opacity: 1,       // ensures the size/color is visible
    },
      "& .MuiInputLabel-root.MuiInputLabel-shrink": {
  fontSize: "16px",
  transform: "translate(14px, -9px) scale(1)",
  backgroundColor: "#fff",
  padding: "0 5px",
   color:"#000"
},
  }}
                  />

                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Write a reply..."
                    value={replyText}
                    onChange={(e) => setReplyText(e.target.value)}
                    sx={{
    ...fieldStyle,
    "& .MuiInputBase-input::placeholder": {
      fontSize: "16px", // change as needed
      opacity: 1,       // ensures the size/color is visible
    },
      "& .MuiInputLabel-root.MuiInputLabel-shrink": {
  fontSize: "16px",
  transform: "translate(14px, -9px) scale(1)",
  backgroundColor: "#fff",
  padding: "0 5px",
   color:"#000"
},
  }}
                  />

                  <Button
                    size="small"
                    onClick={() => submitReply(c._id)}
                    sx={smallPrimaryBtn}
                  >
                    Post Reply
                  </Button>
                </Box>
              )}

              {c.replies &&
                c.replies.map((r) => (
                  <Box
                    sx={{
                      ml: { xs: 2, md: 5 },
                      mt: 2,
                      p: 2,
                      borderRadius: "18px",
                      background: "#fff",
                      border: "1px solid rgba(0,120,201,0.10)",
                    }}
                    key={r.id}
                  >
                    <Typography sx={{ fontWeight: 900, color: "#061d34", fontSize: 13 }}>
                      {r.name}
                    </Typography>

                    <Typography sx={{ color: "#000", fontSize: 12 }}>
                      {r.date}
                    </Typography>

                    <Typography sx={{ color: "#334155", fontSize: 14, mt: 1 }}>
                      {r.comment}
                    </Typography>
                  </Box>
                ))}
            </Box>
          ))}
        </Box>
      </Box>

      {/* LEAVE COMMENT */}
      <Box
        sx={{
          p: { xs: 3, md: 4 },
          borderRadius: "32px",
          background: "#fff",
          border: "1px solid rgba(0,120,201,0.14)",
          boxShadow: "0 18px 50px rgba(6,29,52,0.08)",
        }}
      >
        <Typography
          sx={{
            color: "#061d34",
            fontSize: 26,
            fontWeight: 700,
            mb: 3,
          }}
        >
          Leave a Comment
        </Typography>

        <TextField
          label="Name"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
          sx={{
    ...fieldStyle,
    "& .MuiInputBase-input::placeholder": {
      fontSize: "16px", // change as needed
      opacity: 1,       // ensures the size/color is visible
    },
      "& .MuiInputLabel-root.MuiInputLabel-shrink": {
  fontSize: "16px",
  transform: "translate(14px, -9px) scale(1)",
  backgroundColor: "#fff",
  padding: "0 5px",
   color:"#000"
},
  }}
        />

        <TextField
          label="Email"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{
    ...fieldStyle,
    "& .MuiInputBase-input::placeholder": {
      fontSize: "16px", // change as needed
      opacity: 1,       // ensures the size/color is visible
    },
      "& .MuiInputLabel-root.MuiInputLabel-shrink": {
  fontSize: "16px",
  transform: "translate(14px, -9px) scale(1)",
  backgroundColor: "#fff",
  padding: "0 5px",
   color:"#000"
},
  }}
        />

        <TextField
          label="Comment"
          fullWidth
          multiline
          rows={4}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          sx={{
    ...fieldStyle,
    "& .MuiInputBase-input::placeholder": {
      fontSize: "16px", // change as needed
      opacity: 1,       // ensures the size/color is visible
    },
      "& .MuiInputLabel-root.MuiInputLabel-shrink": {
  fontSize: "16px",
  transform: "translate(14px, -9px) scale(1)",
  backgroundColor: "#fff",
  padding: "0 5px",
   color:"#000"
},
  }}
        />

        <Button onClick={addComment} sx={primaryBtn}>
          Post Comment
        </Button>
      </Box>
    </Container>

    {loader ? <GlobalLoader /> : null}
  </Box>
);

}


const primaryBtn = {
  px: 3,
  py: 1.25,
  borderRadius: "999px",
  background: "linear-gradient(135deg, #0078c9, #005b98)",
  color: "#fff",
  fontWeight: 900,
  fontSize:14,
  textTransform: "none",
  boxShadow: "0 14px 34px rgba(0,120,201,0.28)",
  "&:hover": {
    background: "linear-gradient(135deg, #9e0b22, #75081a)",
    transform: "translateY(-2px)",
    boxShadow: "0 18px 40px rgba(158,11,34,0.28)",
  },
};

const smallPrimaryBtn = {
  mt: 1,
  px: 2.2,
  py: 0.8,
  borderRadius: "999px",
  background: "#0078c9",
  color: "#fff",
  fontWeight: 800,
  fontSize:14,
  textTransform: "none",
  "&:hover": {
    background: "#9e0b22",
  },
};

const fieldStyle = {
  mb: 2,
  "& .MuiInputLabel-root": {
      fontSize: "14px",
    },
  "& .MuiOutlinedInput-root": {
    borderRadius: "16px",
    fontSize: "16px",
    "& fieldset": {
      borderColor: "rgba(0,120,201,0.16)",
    },
    "&:hover fieldset": {
      borderColor: "#0078c9",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#0078c9",
    },
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#0078c9",
  },
};

export default BlogPreview;